export default __webpack_public_path__ + "static/media/728x90-2.119ccec6.gif";